module.exports = __webpack_public_path__ + "static/img/mica-1.283203e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mica-1.jpg
// module id = pXTT
// module chunks = 1